import React, { createContext, useContext, useState, useEffect } from "react";

export const ResponsiveContext = createContext();

export const ResponsiveProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isPhoneLandscape, setIsPhoneLandscape] = useState(false);
  const [shouldShowHamburgerMenu, setShouldShowHamburgerMenu] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      // More precise breakpoints for better device handling
      // Mobile: < 640px (iPhone portrait)
      // Phone Landscape: 640px - 896px (iPhone landscape - most iPhones are 667-926px in landscape)
      // Tablet: 896px - 1024px (iPad portrait)
      // Desktop: >= 1024px (iPad landscape, desktop)
      setIsMobile(width < 640);
      setIsPhoneLandscape(width >= 640 && width < 896);
      setIsTablet(width >= 896 && width < 1024);
      setIsDesktop(width >= 1024);

      // Simple rule: if not enough space for full menu, show hamburger
      // Estimated menu width needed: ~1200px (8 items + More dropdown + gaps)
      // Account for logo space (~200px) and some padding
      const availableWidth = width - 200;
      const needsHamburger = availableWidth < 1200 || width < 1024;
      setShouldShowHamburgerMenu(needsHamburger);

      // Debug logging
      console.log("Responsive Debug:", {
        width,
        height,
        isMobile: width < 640,
        isPhoneLandscape: width >= 640 && width < 896,
        isTablet: width >= 896 && width < 1024,
        isDesktop: width >= 1024,
        shouldShowHamburgerMenu: needsHamburger,
        availableWidth,
      });
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const value = {
    isMobile,
    isTablet,
    isDesktop,
    isPhoneLandscape,
    shouldShowHamburgerMenu,
  };

  return (
    <ResponsiveContext.Provider value={value}>
      {children}
    </ResponsiveContext.Provider>
  );
};

export const useResponsive = () => {
  const context = useContext(ResponsiveContext);
  if (context === undefined) {
    throw new Error("useResponsive must be used within a ResponsiveProvider");
  }
  return context;
};
